import React, {useState} from "react";
import {Content} from "../../styles/GlobalStyles";
import AuthContainer from "../../containers/AuthContainer";
import {
   CardAuth,
   TitleAuth,
   ContentAuth,
   TextAuth,
   CardOptions,
   FormAuth,
   InputAuth,
   ButtonOption,
   ContainerButtons,
} from "./components/AuthStyles";
import {privateEmail} from "./components/Helpers";
import {RecoverPasswordService} from "../../services/UserServices";
import AppLoader from "../../components/loaders/Loader";

export default function RecoverPassword() {
   const [sent, setSent] = useState(false);
   const [email, setEmail] = useState(false);
   const [isLoading, setLoading] = useState(false);

   const SendEmail = (e) => {
      e.preventDefault();
      setLoading(true);
      let email = e.target.email.value;
      RecoverPasswordService({email}) 
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setEmail(email);
            setSent(true);
         })
         .then(() => {
            setLoading(false);
         })
         .catch((e) => {
            setLoading(false);
            console.log(e);
         });
   };
   return (
      <>
         <AuthContainer>
            <Content>
               <ContentAuth>
                  <CardAuth>
                     {!sent ? (
                        <>
                           <div className="head">
                              <TitleAuth>¿Olvidaste tu contraseña?</TitleAuth>
                           </div>
                           <CardOptions>
                              <TextAuth>
                                 Si has olvidado tu contraseña podemos enviarte un correo a la dirección con la que creaste tu cuenta Domecq
                                 Academy y podrás restablecerla.
                              </TextAuth>
                              <FormAuth onSubmit={SendEmail} className="recover">
                                 <InputAuth type="email" required name="email" placeholder="Correo electrónico*" />
                                 <ContainerButtons align="flex-start" className="recover">
                                    <ButtonOption className="widthAuto">Recuperar contraseña</ButtonOption>
                                 </ContainerButtons>
                              </FormAuth>
                           </CardOptions>
                        </>
                     ) : (
                        <SuccessEmail email={email} />
                     )}
                  </CardAuth>
               </ContentAuth>
            </Content>
         </AuthContainer>
         <AppLoader isVisible={isLoading} />
      </>
   );
}

export function SuccessEmail({email}) {
   return (
      <>
         <div className="head">
            <TitleAuth>¿Olvidaste tu contraseña?</TitleAuth>
         </div>
         <CardOptions>
            <TextAuth>Hemos enviado un correo a {privateEmail(email)} para restablecer tu contraseña</TextAuth>
         </CardOptions>
      </>
   );
}
